<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">UPnP</h4>
        <el-alert
            title="No  found internet wan! Please create a new internet wan."
            type="warning"
            show-icon
            :closable="false"
            v-if="isFoundWan">
        </el-alert>
        <el-form 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :model="form" 
            ref="form"
            :disabled="$G_DEVICE_CFG.isReadOnly || isFoundWan"
            >
            <el-form-item label="UPnP Enable:">
                <el-switch v-model="upnpEnable" ></el-switch>
            </el-form-item>
            <el-form-item label="Interface Selection:" v-if="upnpEnable" prop="wanIndex"  
            :rules="[ { required: true, message: 'Please select a internet wan.', trigger: 'change' }]">
                <el-select v-model="form.wanIndex" placeholder="Please select" style="width: 100%">
                    <el-option v-for="item in wanNname" :key="item.wanIndex" :label="item.wanName" :value="item.wanIndex"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">Apply</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            wanNname:[],
            isFoundWan:false,
            form:{
                wanIndex:''
            },
            upnpEnable:false
        }
    },
    created(){
        this.getData()
    },

    methods: {
        getData() {
            this.loading = true
            axios
            .post("/JSONAPI",{cmdType:"GET_WEB_UPNP"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.upnpEnable = response.data.unnpEnable
                    this.wanNname = response.data.wanList
                    this.form.wanIndex = response.data.wanIndex
                    this.isFoundWan = this.wanNname.length === 0
                }
                else
                    this.$message.error(`GET data failed!Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        setData(){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WEB_UPNP",
                wanIndex:parseInt(this.form.wanIndex),
                upnpEnable:this.upnpEnable
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Configuration is success!')
                }
                else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('SET UPnP failed! Network connection error!')
            })
        },
        submitForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },

    },
}
</script>




